import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        width: 'fit-content',
        max_width: '100%',
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        border_style: 'solid',
        border_radius: FOUNDATIONS.radius_comp_status_tag_radiussize,
        border_width: FOUNDATIONS.border_50,
        padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_150}`,
        gap: FOUNDATIONS.spacing_100,
    },
    icon: {
        width: FOUNDATIONS.size_200,
        height: FOUNDATIONS.size_200,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_550,
        font_weight: FONT_WEIGHT.font_weight_600,
        overflow: 'hidden',
        white_space: 'nowrap',
        text_overflow: 'ellipsis',
        text_transform: 'uppercase',
    },
});
//# sourceMappingURL=commonStyles.js.map